module.exports = __webpack_public_path__ + "static/media/userAvatar.5c3ac5ae.png";